(function () {
    'use strict';

    angular
        .module('app')
        .directive('headerSearch', headerSearch);

    headerSearch.$inject = ['$window'];

    function headerSearch($window) {
        // Usage:
        //     <headerSearch></headerSearch>
        // Creates:
        // 
        var directive = {
            bindToController: true,
            controller: ['$scope', '$http', controller],
            controllerAs: '$headerSearch',
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope) {
            $(document).ready(function () {
                $("#nav-search").click(function () {
                   // $(".search-nav").toggleClass("hide");
                   $("#nav-search a.dropdown-toggle").toggleClass("hide");
                    $(this).toggleClass("open");
                    $(".search-icon").click(function () {
                        $(this).toggleClass("open");
                    });
                });

                $("#mobile-search").click(function () {
                    $(".search-mobile-open").toggleClass("hide");
                    $("#nav-search a.dropdown-toggle").toggleClass("hide");
                    $(this).toggleClass("open");
                    $(".search-icon").click(function () {
                        $(this).toggleClass("open");
                    });
                });

                function resetSearchWindow(obj) {
                    $("#searchSuggestions").removeClass("hide");
                    //$(".search-nav").toggleClass("hide");
                    $("#nav-search a.dropdown-toggle").toggleClass("hide");
                    obj.toggleClass("open");
                    $("#headerSearch").val('');
                   // $("#headerSearch").focus();
                }

                //do nothing when clicked inside search window
                $(".search-nav").click(function (e) {
                    e.stopPropagation();
                });
                //hide search-window when user clicks outside of the search window
                $(document).click(function (e) {
                    //console.log("clicked outside of search window");
                    if (!$(".search-nav").hasClass("hide")) {
                        resetSearchWindow($("#nav-search"));
                    }
                });
            });

            $("#headerSearch111").autocomplete({
                highlight: true,
                appendTo: '#header-search-autocomplete',
                source: function (request, response) {
                    $.ajax({
                        url: "/api/search/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.headerSearchAutocompSize
                        },
                        success: function (data) {

                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
                },
                select: function (event, ui) {
                    $(this).val(ui.item.value);
                    $(this).trigger('input'); // Use for Chrome/Firefox/Edge
                    $(this).trigger('change');
                    $(this).closest('form').submit();
                },
                minLength: 2
            });
            $("#mobileHeaderSearch111111111").autocomplete({
                highlight: true,
                appendTo: '#mobile-header-search-autocomplete',
                source: function (request, response) {
                    $.ajax({
                        url: "/api/search/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.headerSearchAutocompSize
                        },
                        success: function (data) {

                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
                },
                select: function (event, ui) {
                    $(this).val(ui.item.value);
                    $(this).trigger('input'); // Use for Chrome/Firefox/Edge
                    $(this).trigger('change');
                    $(this).closest('form').submit();
                },
                minLength: 2
            });
            
            $(window).scroll(function () {
                if ($(window).scrollTop() >= 5) {
                    $('header').addClass('sticky');
                } else {
                    $('header').removeClass('sticky');
                }
            });
        }

        function controller($scope, $http) {
            var $ctrl = this;

            $ctrl.text = "";

            $ctrl.search = function (e, q, searchUrl) {
                searchUrl = '/search';
                if (e) {
                    e.preventDefault();
                }

                //DATA LAYER SCRIPTS MB
                var obj = {
                    'SearchText': q,
                    'SearchPage': window.location.href
                };
                updateDatalayer_SearchPage(obj, 'SearchQuery');

                $window.location.href = searchUrl + "?query=" + encodeURIComponent(q);
                //$window.location.href = searchUrl + "?searchtext=" + encodeURIComponent(q);
            }
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_headerSearch.js
// module id = 11
// module chunks = 0